module.exports = __webpack_public_path__ + "img/forgot-password.b278fb0d.svg";